import {FuseConfig} from '../../@fuse/types';

export let fuseConfig_energypac_airflow_theme: FuseConfig = {

    // Color themes can be defined in src/app/app.theme.scss
    colorTheme      : 'theme-energypac-air-flow',
    customScrollbars: true,
    layout          : {
        style    : 'vertical-layout-1',
        width    : 'fullwidth',
        navbar   : {
            primaryBackground  : '#FAA61A',
            secondaryBackground: 'green-900',
            folded             : false,
            hidden             : false,
            position           : 'left',
            variant            : 'vertical-style-2'
        },
        toolbar  : {
            customBackgroundColor: false,
            background           : 'fuse-white-500',
            hidden               : false,
            position             : 'below-static'
        },
        footer   : {
            customBackgroundColor: true,
            background           : 'fuse-navy-900',
            hidden               : true,
            position             : 'below-fixed'
        },
        sidepanel: {
            hidden  : false,
            position: 'right'
        }
    }
};
